import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { SplashscreenService } from 'src/app/shared/services/splashscreen.service';

@Injectable()
export class LastSearchDataService {
  constructor(
    private readonly http: HttpClient,
    private readonly splashscreenService: SplashscreenService
  ) { }

  getLastSearch(): Observable<any> {
    return this.http.get('/api/lastSearch').pipe(
      tap({
        next: () => this.splashscreenService.notifyFirstWidgetDataLoaded(),
        error: () => this.splashscreenService.notifyFirstWidgetDataLoaded()
      })
    );
  }
}
